export class StripeService {
    axiosInstances;
    constructor(axiosInstances) {
        this.axiosInstances = axiosInstances;
    }
    adminPortal = {
        customer: {
            fetch: async (customerId) => {
                const { data } = await this.axiosInstances.mainInstance.get(`/stripe/customer/${customerId}`);
                return data;
            },
        },
    };
    customerPortal = {
        order: {
            create: async (order) => {
                const { data } = await this.axiosInstances.mainInstance.post('/stripe/order', order);
                return data;
            },
        },
    };
}
//# sourceMappingURL=Stripe.service.js.map